import { Component } from '@verndale/core';
import Swiper, { Navigation, Pagination, Keyboard, A11y } from 'swiper';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      container: this.el.querySelector('.swiper-container'),
      wrapper: this.el.querySelector('.swiper-wrapper'),
      pagination: this.el.querySelector('.swiper-pagination'),
      next: this.el.querySelector('.swiper-button-next'),
      prev: this.el.querySelector('.swiper-button-prev')
    };
    this.initSlider();
  }

  addListeners() {
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  handleResize() {
    this.initSlider();
  }

  initSlider() {
    // eslint-disable-next-line new-cap
    this.slider = new Swiper(this.dom.container, {
      breakpoints: {
        0: {
          slidesPerGroup: 2,
          slidesPerView: 2,
          spaceBetween: 30,
        },
        600: {
          slidesPerGroup: 3,
          slidesPerView: 3,
          spaceBetween: 30,
        },
        900: {
          slidesPerGroup: 3,
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1080: {
          slidesPerGroup: 5,
          slidesPerView: 5,
          spaceBetween: 30,
        },
      },
      breakpointsBase: "container",
      centerInsufficientSlides: true,
      grabCursor: true,
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
      loop: false,
      modules: [Navigation, Pagination, Keyboard, A11y],
      navigation: {
        hideOnClick: false,
        nextEl: this.dom.next,
        prevEl: this.dom.prev
      },
      pagination: {
        clickable: true,
        el: this.dom.pagination
      },
      speed: 350,
    });
  }


}

export default Module;
